import {BrowserModule} from '@angular/platform-browser';
import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {MDBBootstrapModule} from 'angular-bootstrap-md';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FooterComponent} from './components/footer/footer.component';
import {HeaderComponent} from './components/header/header.component';
import {CoreComponent} from './components/core/core.component';
import {DashboardComponent} from './components/core/dashboard/dashboard.component';
import {HelpComponent} from './components/core/help/help.component';
import {AboutComponent} from './components/core/about/about.component';
import {HttpClientModule} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import {DeviceDetectorModule} from 'ngx-device-detector';
import {NouisliderModule} from 'ng2-nouislider';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {CameraViewComponent} from './components/core/dashboard/camera-view/camera-view.component';
import {MenuComponent} from './components/core/dashboard/menu/menu.component';
import {HeaderLiteComponent} from './components/header-lite/header-lite.component';
import {ChartComponent} from './components/core/dashboard/chart/chart.component';
import {StatisticsChartComponent} from './components/core/dashboard/statistics-chart/statistics-chart.component';
import {NgOpenCVModule, OpenCVOptions} from 'ng-open-cv';
import {CameraService} from './services/camera/camera.service';
import {FaceRecognitionService} from './services/face-recognition/face-recognition.service';
import {OpencvComponent} from './components/core/opencv/opencv.component';
import {SpeechComponent} from './components/core/speech/speech.component';
import {CameraComponent} from './components/core/opencv/camera/camera.component';
import {OpencvMenuComponent} from './components/core/opencv/opencv-menu/opencv-menu.component';
import {SpeechToTextComponent} from './components/core/speech-to-text/speech-to-text.component';
import {SpeechToTextService} from './services/speech-to-text/speech-to-text.service';
import {SpeechService} from './services/speech/speech.service';
import {RadarChartComponent} from './components/core/speech/radar-chart/radar-chart.component';
import {SemanticsComponent} from './components/core/semantics/semantics.component';
import {FaceapiComponent} from './components/core/faceapi/faceapi.component';
import {FaceDetectionComponent} from './components/core/faceapi/face-detection/face-detection.component';
import {
  FaceLandmarkDetectionComponent
} from './components/core/faceapi/face-landmark-detection/face-landmark-detection.component';
import {
  FaceExpressionDetectionComponent
} from './components/core/faceapi/face-expression-detection/face-expression-detection.component';
import {
  FaceAgeGenderDetectionComponent
} from './components/core/faceapi/face-age-gender-detection/face-age-gender-detection.component';
import {FaceApiConfigComponent} from './components/core/faceapi/face-api-config/face-api-config.component';

const openCVConfig: OpenCVOptions = {
  scriptUrl: `assets/opencv/opencv.js`,
  wasmBinaryFile: 'wasm/opencv_js.wasm',
  usingWasm: true
};

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    CoreComponent,
    DashboardComponent,
    HelpComponent,
    AboutComponent,
    CameraViewComponent,
    MenuComponent,
    HeaderLiteComponent,
    ChartComponent,
    StatisticsChartComponent,
    OpencvComponent,
    SpeechComponent,
    CameraComponent,
    OpencvMenuComponent,
    SpeechToTextComponent,
    RadarChartComponent,
    SemanticsComponent,
    FaceapiComponent,
    FaceDetectionComponent,
    FaceLandmarkDetectionComponent,
    FaceExpressionDetectionComponent,
    FaceAgeGenderDetectionComponent,
    FaceApiConfigComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    MDBBootstrapModule.forRoot(),
    BrowserAnimationsModule,
    NouisliderModule,
    DeviceDetectorModule.forRoot(),
    NgOpenCVModule.forRoot(openCVConfig),
    AppRoutingModule
  ],
  providers: [
    CookieService,
    HttpClientModule, CameraService, FaceRecognitionService, SpeechToTextService, SpeechService],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule {
}
